import { render, staticRenderFns } from "./classifyTable.vue?vue&type=template&id=65ecb0ec&scoped=true&"
import script from "./classifyTable.vue?vue&type=script&lang=js&"
export * from "./classifyTable.vue?vue&type=script&lang=js&"
import style0 from "./classifyTable.vue?vue&type=style&index=0&id=65ecb0ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ecb0ec",
  null
  
)

export default component.exports